import gql from 'graphql-tag'
import client from '@stores/apollo'
import { BMDialogBuildingFragment } from '@api/fragments'
import { UpdateBuildingInput, BMDialogBuilding } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  updateBuilding: { building: BMDialogBuilding }
}

const mutateHandler = handleFetchResult<IPayload, BMDialogBuilding>({
  handler: (data) => data.updateBuilding.building,
  name: 'Building',
})

export default function update(input: UpdateBuildingInput) {
  return client.gql.mutate({ mutation, variables: { input } }).then(mutateHandler)
}

const mutation = gql`
  mutation UpdateBuilding($input: UpdateBuildingInput!) {
    updateBuilding(input: $input) {
      building {
        ...BMDialogBuildingFragment
      }
    }
  }
  ${BMDialogBuildingFragment}
`
